<a *ngIf="internal && path" [routerLink]="path">
  <ng-container *ngTemplateOutlet="img"></ng-container>
</a>
<a *ngIf="!internal && path" [href]="path">
  <ng-container *ngTemplateOutlet="img"></ng-container>
</a>
<ng-container *ngIf="!path">
  <ng-container *ngTemplateOutlet="img"></ng-container>
</ng-container>

<ng-template #img>
  <img
    title="Cigna Logo"
    alt="Cigna Logo"
    width="162"
    height="55"
    [src]="'assets/images/cigna-logo.svg' | cdnPrefix"
    data-test="header-cigna-logo"
  />
</ng-template>
